import type { ReactNode } from 'react'

import styles from './KpiCard.module.css'

interface KpiCardProps {
  label: string
  value: ReactNode
  sub?: ReactNode
  tone?: 'good' | 'bad' | null
  /** Render the value as body text instead of tabular money (e.g. a department name). */
  textValue?: boolean
  /** Makes the card a button that drills into transactions. */
  onActivate?: () => void
  activateLabel?: string
}

export function KpiCard({ label, value, sub, tone, textValue, onActivate, activateLabel }: KpiCardProps) {
  const valueClass = [styles.value, textValue ? styles.valueText : 'num', tone ? styles[tone] : '']
    .filter(Boolean)
    .join(' ')
  const content = (
    <>
      <div className={styles.label}>
        {label}
        {onActivate ? <span className={styles.hint}>view transactions</span> : null}
      </div>
      <div className={valueClass}>{value}</div>
      {sub ? <div className={styles.sub}>{sub}</div> : null}
    </>
  )
  if (onActivate) {
    return (
      <button type="button" className={styles.kpi} onClick={onActivate} aria-label={activateLabel}>
        {content}
      </button>
    )
  }
  return <div className={styles.kpi}>{content}</div>
}
